"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const twing_1 = require("twing");
const formats = require("format-message-formats");
class TwingExtensionIntl extends twing_1.TwingExtension {
    constructor(content) {
        super();
        if (!Intl.DateTimeFormat) {
            throw new Error('intl (https://developer.mozilla.org/de/docs/Web/JavaScript/Reference/Global_Objects/Intl) is needed to use intl-based filters.');
        }
    }
    getFilters() {
        return new Map([
            [0, new twing_1.TwingFilter('localizeddate', TwingExtensionIntl.localizeddate, { needs_environment: true })],
        ]);
    }
    static getLocale(locale) {
        return locale ? locale : navigator.language;
    }
    // we need some help as js intl is not yet ready
    // @see https://github.com/tc39/proposal-intl-datetime-style
    static localizeddate(env, date, dateFormat = 'medium', timeFormat = 'medium', locale = null, timezone = null, format = null, calendar = 'gregorian') {
        var options = {};
        if (timezone) {
            Object.assign(options, {
                timeZone: timezone,
                timeZoneName: 'short'
            });
        }
        if (dateFormat) {
            Object.assign(options, formats.date[dateFormat] || formats.parseDatePattern(dateFormat) || formats.date.default);
        }
        if (timeFormat) {
            Object.assign(options, formats.time[timeFormat] || formats.parseDatePattern(timeFormat) || formats.time.default);
        }
        return new Intl.DateTimeFormat(TwingExtensionIntl.getLocale(locale), options).format(date);
    }
    static localizednumber(number, style = 'decimal', type = 'default', locale = null) {
        // @TODO implement me
    }
    static localizedcurrency(number, $currency = null, $locale = null) {
        // @TODO implement me
    }
}
exports.TwingExtensionIntl = TwingExtensionIntl;
